import { PAGE_SIZE_MOBILE, PAGE_SIZE_WEB } from 'shared/config'
import { useResponsive } from 'shared/hooks'

export const usePageSize = () => {
    const { md } = useResponsive()
    const pageSize = md ? PAGE_SIZE_WEB : PAGE_SIZE_MOBILE

    return pageSize
}
